/**
 * The following scripts get applied on the frontend of your site.
 */

jQuery(document).ready(function ($) {

    $('.postarchive').each(function () {

        
        let postarchive = $(this);
        const presets = JSON.parse(postarchive.attr('data-atts'));
        const hasSubmitButton = postarchive.find('button[type="submit"]').length > 0;
        /**
         * Fetch postarchive data
        */
       function fetch_postarchive_data(append = false) {
            data_attributes = JSON.parse(postarchive.attr('data-atts'));
            data_template = postarchive.attr('data-template');
            data_heading = postarchive.attr('data-heading');
            postarchive.addClass('loading');

            $.ajax({
                type: 'POST',
                url: Blocks.ajaxurl,
                data: {
                    action: 'fetch_data',
                    ajaxnonce: Blocks.ajaxnonce,
                    attributes: JSON.stringify(data_attributes),
                    template: data_template,
                    heading: data_heading,
                },
                success: function (response) {
                    if (response?.data) {
                        console.log(response.has_more_posts)
                        if (append) {
                            postarchive.find('.posts').append(response.data);
                        } else {
                            postarchive.find('.posts').html(response.data);
                        }
                        if (!response.has_more_posts) {
                            postarchive.find('.loadmore').hide();
                        } else {
                            postarchive.find('.loadmore').show();
                        }
                    } else {
                        postarchive.find('.posts').html("");
                        postarchive.find('.loadmore').hide();
                    }
                    postarchive.removeClass('loading');
                },
                error: function (MLHttpRequest, textStatus, errorThrown) {
                    console.log(errorThrown);
                }
            });

            postarchive.attr('data-atts', JSON.stringify(data_attributes));
        }


        /**
         * Search
         */
        postarchive.find('.search-filter').each(function (e) {

            // define variables
            $search = $(this);
            $button = $(this).find('button[type="submit"]');
            $input = $(this).find('input[type="search"]');

            // button click
            $button.on('click', function (e) {

                // prevent form submit
                e.preventDefault();

                // update data attributes
                data_attributes = JSON.parse(postarchive.attr('data-atts'));
                data_attributes['s'] = $input.val();
                data_attributes['paged'] = 1;
                postarchive.attr('data-atts', JSON.stringify(data_attributes));

                // fetch posts on change if there is no submit button
                if (!hasSubmitButton) {
                    fetch_postarchive_data();
                }
            });

            // trigger button on enter in input
            $input.on('keypress', function (e) {
                if (e.which == 13) {
                    $button.trigger('click');
                }
            })
        });


        /**
         * Load more
         */
        postarchive.find('.loadmore').on('click', function () {

            // update data attributes
            data_attributes = JSON.parse(postarchive.attr('data-atts'));
            data_attributes['paged'] = (parseInt(data_attributes['paged']) || 1) + 1;
            postarchive.attr('data-atts', JSON.stringify(data_attributes));

            // fetch posts
            fetch_postarchive_data(true);

        });

        /**
         * Filter posts
         */
        postarchive.find('.year-filter, .category-filter').each(function () {

            // define global variables           
            $parent = $(this);
            data_attributes = JSON.parse(postarchive.attr('data-atts'));

            $(this).find('input, select').on('click change', function () {

                years = [];
                categories = [];

                // get years and categories
                $parent.find('input:checked').each(function () {
                    if ($parent.hasClass('year-filter')) {
                        years.push($(this).val());
                    }
                    if ($parent.hasClass('category-filter')) {
                        categories.push(parseInt($(this).val()));
                    }
                });
                $parent.find('select option:checked').each(function () {
                    if (typeof $(this).val() !== null && $(this).val() != "") {
                        if ($parent.hasClass('year-filter')) {
                            years.push($(this).val());
                        }
                        if ($parent.hasClass('category-filter')) {
                            categories.push(parseInt($(this).val()));
                        }
                    }
                });

                // update data attributes                
                data_attributes['paged'] = 1;
                data_attributes['years'] = years;
                data_attributes['categories'] = (categories.length && categories) || presets?.categories;
                postarchive.attr('data-atts', JSON.stringify(data_attributes));

                // fetch posts on change if there is no submit button
                if (!hasSubmitButton) {
                    fetch_postarchive_data();
                }
            })

        })

        /**
         * Reset
         */
        postarchive.find('button[type="reset"]').on('click', function () {

            // update data attributes
            postarchive.attr('data-atts', JSON.stringify(presets));

            // reset select fields
            $("select").closest("form").on("reset", function (ev) {
                var target = $(ev.target);
                setTimeout((function () { this.find("select").trigger("change") }).bind(target), 0);
            });

            // fetch posts
            fetch_postarchive_data();
        })

        /**
         * Submit
         */
        postarchive.find('button[type="submit"]').on('click', function (e) {

            // prevent default submit
            e.preventDefault();

            // fetch posts
            fetch_postarchive_data();
        })

    });


});